/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { V1AmountModel } from '../../entities/v1/AmountModel'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { z } from 'zod'

export const v1AmountModelSchema = z.object({
  cash: z.number(),
  non_cash: z.number(),
  total: z.number(),
}) as unknown as ToZod<V1AmountModel>